<template>
  <section class="credits-faq  container">
    <div class="credits-faq__content  container-inner">
      <h2 class="credits-faq__title">{{ $tCredits('Often asked') }}</h2>
      <AccordionInfo :items="section"
                     nameKey="question"
                     contentKey="answer"
                     class="credits-faq__faq"/>
    </div>
  </section>
</template>

<script>
  import AccordionInfo from '@/components/AccordionInfo'

  export default {
    name: 'CreditsPageFAQ',
    components: {
      AccordionInfo
    },
    props: {
      section: Array
    },
    data() {
      return {

      }
    }
  }
</script>

<style lang="less">

</style>